// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { useViewportContext } from '../../../contexts/ViewportContext';
import useModalContext from '../../../hooks/useModalContext';
import KLOrientationStepContainer from '../containers/KLOrientationStepContainer';
import KLCollectibleBetslipDetailsCardContainer from '../containers/KLOrientationStepDetailsCardContainer';
import KLOrientationStepRulesDetailsContainer from '../containers/KLOrientationStepRulesDetailsContainer';
import { type KLCollectibleId, type KLCollectibleStatus } from '../types/collectible';
import { KLViewTypes } from '../types/view';

import KLViewWrapper from './common/KLViewWrapper';

const Wrapper = styled(KLViewWrapper)`
  padding: 0;
`;

const Background = styled(KLViewWrapper)`
  position: absolute;
  z-index: -1;
  filter: blur(0.4em);
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 1em;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  max-height: ${({ $maxHeight }) => $maxHeight}px;
  overflow-y: auto;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: bold;
  font-size: 1.5em;
  background: black;
  border-radius: 2em;
  width: fit-content;
  padding: 0.1em 1em 0em 1em;
  margin-bottom: 1em;
  color: #ffc514;
`;

const StepWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledStep = styled(KLOrientationStepContainer)`
  font-size: 2.5em;
`;

const StyledDetailsCard = styled(KLCollectibleBetslipDetailsCardContainer)`
  max-height: 35%;
  padding-top: 1em;
`;

type KLOrientationStepDetailsProps = {
  className?: string;
  stepId: KLCollectibleId;
  progressIndex: number;
  status: KLCollectibleStatus;
  betslipReference?: string;
};

const KLOrientationStepDetails = ({
  className = '',
  stepId,
  progressIndex,
  status,
  betslipReference,
}: KLOrientationStepDetailsProps) => {
  const paginationLabel = useMemo(() => ['Zone A', 'Zone B', 'Zone C'][progressIndex], [progressIndex]);
  const { height, navbarHeight, tabbarHeight } = useViewportContext();
  const { height: modalHeight } = useModalContext();

  const availableHeight = useMemo(
    () => (modalHeight ? modalHeight : height - navbarHeight - tabbarHeight),
    [height, modalHeight, navbarHeight, tabbarHeight],
  );

  return (
    <Wrapper className={className}>
      <Background viewType={KLViewTypes.ORIENTATION} />
      <Content $maxHeight={availableHeight}>
        <Header>{paginationLabel}</Header>
        <StepWrapper>
          <StyledStep stepId={stepId} paginationIndex={progressIndex} disableInteraction />
        </StepWrapper>
        {betslipReference ? (
          <StyledDetailsCard betslipReference={betslipReference} status={status} />
        ) : (
          <KLOrientationStepRulesDetailsContainer stepId={stepId} />
        )}
      </Content>
    </Wrapper>
  );
};

export default KLOrientationStepDetails;
